module.exports = __webpack_public_path__ + "static/enterprise-search-dab19cbbe8ad50cac8c627495428c706.png";